import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';

interface Props {
  remainingCount: number;
}
const SegmentsCompletedNone: React.FC<Props> = ({ remainingCount }) => {
  return (
    <span data-test-segments-remaining={remainingCount}>
      <T kind="You have {{count}} step remaining" count={remainingCount} />
    </span>
  );
};

export default observer(SegmentsCompletedNone);
